// extracted by mini-css-extract-plugin
module.exports = {"dashboardLetters":"dashboard-letters_dashboardLetters__1Ktxc","header":"dashboard-letters_header__2PGAx","stats":"dashboard-letters_stats__3NFne"};